import React from 'react';
import { motion } from 'framer-motion';
import { Check, Shield, Smartphone } from 'lucide-react';
export function SolutionSection() {
  return <section className="w-full bg-black py-20 px-4 text-white" data-id="element-242">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-243">
        <div className="text-center mb-10" data-id="element-244">
          <span className="bg-yellow-500/20 text-yellow-400 border border-yellow-500/50 px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-245">
            La solución
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-white mt-6 leading-tight" data-id="element-246">
            Presentamos "Electricista en Casa"
            <br data-id="element-247" />
            La Colección Completa en 4 Tomos
          </h2>
        </div>

        <p className="text-xl text-gray-300 font-medium text-center max-w-3xl mb-12" data-id="element-248">
          No es un curso online. No es un manual técnico. Es un sistema práctico
          de 4 tomos diseñado para que puedas resolver cualquier avería
          doméstica paso a paso, desde el primer día, con total seguridad.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-3xl mb-12" data-id="element-249">
          {['Sin título ni certificación previa necesaria', 'Sin herramientas caras ni equipos especiales', 'Sin vídeos que pausar y rebobinar 10 veces', 'Con checklists y protocolos listos para usar', 'Con instrucciones paso a paso para cada avería', 'Ahorrás entre 400€ y 800€ al año desde el primer mes'].map((item, idx) => <div key={idx} className="flex items-start gap-3 bg-gray-900 p-4 rounded-lg border border-gray-800" data-id="element-250">
              <div className="bg-blue-600/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-251">
                <Check className="text-blue-400" size={20} strokeWidth={3} data-id="element-252" />
              </div>
              <span className="text-gray-100 font-semibold text-lg" data-id="element-253">
                {item}
              </span>
            </div>)}
        </div>

        <motion.a href="#compra" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="bg-yellow-400 hover:bg-yellow-500 text-black font-black text-lg md:text-2xl py-4 md:py-5 px-8 md:px-12 rounded-lg shadow-[0_5px_0_rgb(202,138,4)] hover:shadow-[0_2px_0_rgb(202,138,4)] hover:translate-y-[3px] transition-all w-full max-w-xl text-center uppercase tracking-wide" data-id="element-254">
          ⚡ QUIERO EMPEZAR A AHORRAR HOY →
        </motion.a>

        <div className="mt-6 flex flex-wrap justify-center gap-4 text-sm text-gray-400 font-medium" data-id="element-255">
          <span className="flex items-center gap-1" data-id="element-256">
            <Shield size={16} className="text-gray-400" data-id="element-257" /> Garantía 30 días
          </span>
          <span className="hidden md:inline" data-id="element-258">•</span>
          <span className="flex items-center gap-1" data-id="element-259">
            <Smartphone size={16} className="text-gray-400" data-id="element-260" /> Acceso inmediato
          </span>
        </div>
      </div>
    </section>;
}